import SavedReplyInserterComponent from '@intercom/embercom-composer/components/saved-reply-inserter';
export default SavedReplyInserterComponent;
